import { SavedLocationIcon } from '@hero/web-icons';
import { cn } from '@hero/web-lib';

interface SavedLocationDisplayProps {
  savedLocationName: string;
  className?: string;
}

export function SavedLocationDisplay({ savedLocationName, className }: SavedLocationDisplayProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2 py-1 bg-gradient-to-r from-teal-50 to-cyan-50 text-teal-700 font-medium text-sm rounded-md border border-teal-200 shadow-sm',
        className,
      )}>
      <SavedLocationIcon className="flex-shrink-0 size-4 text-teal-600" />
      {savedLocationName}
    </span>
  );
}
